<!-- Template for header directive -->

<div class="header-div" [class.header-div-no-points]="hidePoints">
  <div class="header-left-col" style="z-index: 1;">
    @if (!hidePoints) {
      <div class="header-avatar-student-container">
        <object id="userInfoObject" data="../assets/images/headerFooter/userInfo_background.svg"
          type="image/svg+xml">
        </object>
        <div class="header-avatar" [style.background-image]="'url(' + avatarIcon + ')'"
        (dblclick)="moveBackOneLevel($event)" on-double-tap="moveBackOneLevel($event)"></div>
        @if (studentID) {
          <div [class]="{'font-18': (studentID.length || 0) >= 16, 'font-24': (studentID.length || 0) < 16}" class="header-username">{{studentID}}</div>
        }
        <div class="header-points font-24">{{studentDailyPoints | number}}</div>
      </div>
    }

    @if (hidePoints) {
      <div class="header-student-container">
        <object id="usernameObject" data="../assets/images/headerFooter/username_background.svg"
        type="image/svg+xml"></object>
        @if (studentID) {
          <div [class]="{'font-18': (studentID.length || 0) >= 16, 'font-24': (studentID.length || 0) < 16}" class="header-name-hide-points">{{studentID}}</div>
        }
      </div>
    }
  </div>

  @if (showNewTeam) {
    <div class="new-team-dialog-container"></div>
  }
  <div class="header-center-col" [hidden]="hideTeam">
    <div class="header-team-name" [class.header-team-no-points]="hidePoints">
      <div [hidden]="hideTeamName" class="font-30"
        [class.animate-header-team-name]="animateTeamName">{{teamName}}
      </div>
    </div>
    <div class="header-your-team font-14">Your Team</div>
  </div>
  <div class="header-right-col">
    @if (showMaintenanceWarning) {
      <div class="maintenance-warning-dialog">
        <p class="maintenance-warning-text">Application Maintenance at:</p>
        <p class="maintenance-warning-date">{{ maintenanceTimer * 1000 | date: 'h:mm a' }}</p>
        <p class="maintenance-warning-text">You will be logged out upon task completion after this time.</p>
      </div>
    }
    @if (headerBackButtonVisible) {
      <button class='header-logout-button' (click)="headerGoBack()"
      [class]="{'back_button_animate': pulseHeaderGoBackButton && !disableGoBackButton, 'disabled': disableGoBackButton}" [disabled]=disableGoBackButton></button>
    }
  </div>
  <instructions [videoSource]="videoSource" #instructions></instructions>
  @if (showMaintenanceDialog) {
    <maintenance-dialog></maintenance-dialog>
  }
</div>
